import I18n from 'I18n';
export function getKBLibraryPreviewData() {
  const articleNames = {
    howToSetupYourAccount: I18n.text('conversations-visitor-experience-components.knowledgeBase.articleNames.howToSetupYourAccount'),
    managingYourSubscriptionPlan: I18n.text('conversations-visitor-experience-components.knowledgeBase.articleNames.managingYourSubscriptionPlan'),
    dataPrivacyAndSecurity: I18n.text('conversations-visitor-experience-components.knowledgeBase.articleNames.dataPrivacyAndSecurity')
  };
  const categoryNames = {
    gettingStarted: I18n.text('conversations-visitor-experience-components.knowledgeBase.categoryNames.gettingStarted'),
    accountAndBilling: I18n.text('conversations-visitor-experience-components.knowledgeBase.categoryNames.accountAndBilling'),
    troubleshootingAndFaqs: I18n.text('conversations-visitor-experience-components.knowledgeBase.categoryNames.troubleshootingAndFaqs')
  };
  const defaultRecommendedArticles = [{
    id: 123,
    name: articleNames.howToSetupYourAccount,
    knowledgeCategoryId: 321,
    knowledgeCategoryName: categoryNames.gettingStarted,
    url: 'https://kbpreview.com/how-to-setup-your-account'
  }, {
    id: 456,
    name: articleNames.managingYourSubscriptionPlan,
    knowledgeCategoryId: 654,
    knowledgeCategoryName: categoryNames.accountAndBilling,
    url: 'https://kbpreview.com/managing-your-subscription-plan'
  }, {
    id: 789,
    name: articleNames.dataPrivacyAndSecurity,
    knowledgeCategoryId: 654,
    knowledgeCategoryName: categoryNames.accountAndBilling,
    url: 'https://kbpreview.com/data-privacy-and-security'
  }];
  const defaultArticleCategories = [{
    categoryId: 321,
    categoryName: categoryNames.gettingStarted,
    articleCount: 20
  }, {
    categoryId: 654,
    categoryName: categoryNames.accountAndBilling,
    articleCount: 5
  }, {
    categoryId: 987,
    categoryName: categoryNames.troubleshootingAndFaqs,
    articleCount: 12
  }];
  return {
    defaultRecommendedArticles,
    defaultArticleCategories
  };
}